module.exports = __webpack_public_path__ + "static/media/sinpapeleo.0d6d1e4a.webp";